import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChartConfigBuilder } from './highchart-platform-models';
import { IChartConfig, IChartSeries } from './highchart-platform-interfaces';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
@Component({
  selector: 'app-highchart-platform',
  template: `<div id="{{id}}" *ngIf="data || config" style="width:100%; height:400px;"></div>`,
  styles: []
})
export class HighchartPlatformComponent implements OnInit, AfterViewInit, OnChanges {

  tooltip: { headerFormat: any; pointFormat: string; };
  @Input()
  id: string;
  @Input()
  type: string;
  @Input()
  title: string;
  @Input()
  subtitle: string;
  @Input()
  data: IChartSeries[];
  @Input()
  xAxis: string;
  @Input()
  overrideConfig: IChartConfig;
  @Input()
  config: Highcharts.Options;

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    if (this.data || this.config) {
      this.createChart();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      // not sure about the reason but without timeout dom does not take full width
      setTimeout(() => {
        this.createChart();
      }, 10);
    }
  }

  private createChart() {
    const options = this.config ? this.config : this.prepareChartConfig();
    Highcharts.chart(this.id, options);
  }

  private prepareChartConfig(): IChartConfig {
    const builder: ChartConfigBuilder = new ChartConfigBuilder();
    const coreConfig = builder.getBaseConfig(this.type, this.title, this.xAxis, this.subtitle).addSeries(this.data);
    this.overrideConfig ? _.merge(coreConfig, this.overrideConfig): null;
    return coreConfig;
  }
}
